<template>
	<div id="app">
		<van-nav-bar
			v-if="showNavBar"
			:title="title"
			left-arrow
			ref="navBar"
			fixed
			placeholder
			@click-left="goBack"
			:border="true"
		>
			<template slot="left">
				<div>
					<div
						v-if="$route.path == '/index' && mallInfo.mallType != 1"
						style="display: flex; align-items: center"
					>
						<van-icon name="arrow-left" />
						返回
					</div>
					<div v-else>
						<van-icon v-if="$route.path != '/index'" name="arrow-left" />
					</div>
				</div>
			</template>
			<template slot="right">
				<div class="nav-position" @click="$goPage('city')">
					<span>{{ currentCityName }}</span>
					<van-icon
						name="arrow-down"
						size="12"
						style="margin-left: 2px"
						color="#000"
					></van-icon>
				</div>
			</template>
		</van-nav-bar>
		<!-- <h1 @click="cece">这是一个寂寞的天</h1> -->
		<keep-alive>
			<router-view v-if="$route.meta.keepAlive" class="keep" />
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive" />
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Cookies from "js-cookie";
import { getUserLocation } from "@/libs/map-utils.js";
// import { movieCityList } from "@/utils/api.js";
export default {
	computed: {
		...mapGetters(["currentCityCode", "currentCityName"]),
		title() {
			return this.$store.state.app.title;
		},
		platformType() {
			return this.$store.state.app.platformType;
		},
		showNavBar() {
			if (
				this.$route.path == "/movie-session" ||
				this.$route.path == "/cinema-seat" ||
				this.$route.path == "/filmOrder" ||
				this.$route.path == "/checkCard" ||
				this.$route.path == "/login" ||
				this.$route.path == "/useCard"
			) {
				return false;
			}
			return true;
			if (this.platformType.win || this.platformType.iOS) {
				return true;
			}
			return false;
		},
	},
	data() {
		return {
			mallInfo: {},
		};
	},
	created() {
		this.mallInfo = JSON.parse(localStorage.getItem("mallInfo"));
		if (localStorage.getItem("toMovie")) {
			Cookies.remove("_DuMovie_SELECTED_LOCATION");
			Cookies.remove("_DuMovie_LOCATION");
			localStorage.removeItem("_DuMovie_CITY_LIST");
		} else {
			localStorage.removeItem("toMovie");
		}
		if (
			window.location.href.includes("192.168") ||
			window.location.href.includes("localhost")
		) {
			localStorage.setItem(
				"userInfo",
				JSON.stringify({
					birthday: "1900-01-01",
					lastIp: "101.201.72.87",
					mallId: 1,
					remark: "",
					password: "2baebffb2004b46642277ca20a97569e",
					cardNum: 2,
					loginTime: "2022-11-07T12:38:05.000+0000",
					isDeleted: 0,
					nickname: "锦鲤商城1",
					memberId: 3,
					address: null,
					openid: "oGzbz6JubLVmjnNNQTDk5CjHwnms",
					sex: 1,
					mobile: "15170182603",
					updateUser: 3,
					updateTime: "2023-05-25T15:09:09.000+0000",
					avatar:
						"https://quanfuyou.oss-accelerate.aliyuncs.com/20230506/2eceb8cd1bd541c5933384ffb3b9604d.jpg",
					realName: null,
					cleanTime: null,
					createDept: null,
					createTime: "2022-11-07T12:38:05.000+0000",
					cardId: null,
					tenantId: "963422",
					createUser: 0,
					payPassword: "",
					status: 1,
				})
			);
			localStorage.setItem("t", "9634221");
			Cookies.set(
				"9634221token",
				"IICdGcSrRRDD9bcEbhcTknlTP0T9RZtEgVUaP1kFIaKYwS7aS3+rlrPonGpVG50lrBr8+6WcRUvs3dRThMBh6eK22DYnJ98RaRGLUKJzAZ0CaBEajS/fj0PwpccsT1Xqtu86YdrPZoK0nfm6hZbr7XQ3mI6opR0DrQIxmD0tX+A=",
				{
					expires: 30,
				}
			);
			localStorage.setItem(
				"mallInfo",
				JSON.stringify({
					couponName: "u+福利券",
					couponUnit: "豆",
					movieChannel: "you",
					gzhLogo:
						"http://quanfuyou.oss-cn-hangzhou.aliyuncs.com/upload/20230209/ea73b30d31c8432a16f670a8919e0306.jpg",
					id: 1,
					integralUnit: "积分",
					isDeleted: 0,
					jsonString: '{"casepay":1}',
					loginFooter: "",
					loginType: 2,
					mallDiySearch: null,
					mallDiyType: null,
					mallDomain: "",
					mallLicense:
						"http://quanfuyou.oss-cn-hangzhou.aliyuncs.com/upload/20221107/b3465becc358495e6a6c96468eeed35b.jpg",
					mallLogo:
						"http://quanfuyou.oss-cn-hangzhou.aliyuncs.com/upload/20221107/36e70f48507b59cf45da70424317f36b.jpg",
					mallName: "U佳福利",
					mallProductSort: null,
					mallType: 2,
				})
			);
		}
	},
	methods: {
		cece() {
			window.open(
				"https://pre-open.xmgmlc.com/authlogin/#/pages/index/authLogin?clientID=61df7cf73a7a4a2a838462b1a6fa20e1&redirectUrl=https%3A%2F%2Fwww.baidu.com"
			);
		},
		goBack() {
			console.log(this.$route);
			if (this.$route.path == "/index") {
				window.location = `${
					window.location.origin + "/shop/"
				}?t=${localStorage.getItem("t")}`;
			} else {
				this.$goPage(-1);
			}
		},
		// initVConsole() {
		// 	const oScript = document.createElement("script");
		// 	oScript.type = "text/javascript";
		// 	oScript.src = "https://cdn.bootcss.com/vConsole/3.3.0/vconsole.min.js";
		// 	oScript.onload = this.initObj;
		// 	document.body.appendChild(oScript);
		// },
		// initObj() {
		// 	const vConsole = new VConsole();
		// 	console.log("vconsole开启了");
		// },
	},
	mounted() {
		// this.initVConsole();

		Object.keys(this.platformType).forEach((key) => {
			if (this.platformType[key]) {
				console.log("当前运行环境 ->", key);
			}
		});
		getUserLocation();
	},
};
</script>
<style>
/* @font-face {
	font-family: "pf regular";
	src: url("./assets/font/苹方黑体-准-简.ttf");
}

@font-face {
	font-family: "pf medium";
	src: url("./assets/font/苹方黑体-中黑-简.ttf");
} */
</style>
<style lang="scss">
@import "./styles/index.scss";
html,
body,
#app {
	width: 100%;
	height: 100%;
	margin: 0;
	padding: 0;
	// font-family: "pf regular";
	font-family: Avenir, Helvetica, Arial, sans-serif !important;
	-webkit-font-smoothing: antialiased;
}

#app {
	display: flex;
	flex-direction: column;
}

.van-nav-bar {
	.van-icon-arrow-left {
		color: $second-color !important;
	}
}

.van-nav-bar .nav-position {
	font-size: 14px;
}
</style>
